import React, { useRef, useEffect } from "react";
import "./MusicVideoModal.scss";
import { useTranslation } from "react-i18next";

interface MusicVideoModalProps {
  onClose?: () => void;
}

const MusicVideoModal: React.FC<MusicVideoModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const cdnUrl = `https://cdn.bear-shares.com/musicVideo/Spirit%20Bear%20%26%20Friends.mp4`;

  const videoRef = useRef<HTMLVideoElement | null>(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.volume = 0.2;
    }
  }, []);

  return (
    <div className="musicVideo-modal">
      <div className="musicVideo-modal__frame">
        {onClose && (
          <button
            className="musicVideo-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        )}

        <div className="musicVideo-modal__content">
          <div className="musicVideo-modal__video-wrapper">
            <video
              ref={videoRef}
              className="musicVideo-modal__video"
              controls
              preload="metadata"
              playsInline
            >
              <source src={cdnUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="musicVideo-modal__caption">
            <p className="musicVideo-modal__description">
              {t("music_video_description")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicVideoModal;
